import { loginSchema } from '@almacen/shared';
import {
  Alert,
  Button,
  Center,
  Image,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import { errorMessage } from '../../api/client';
import { useAuth } from '../../auth/auth-context';
import { zodValidator } from '../../lib/forms';

export function LoginPage() {
  const { user, login } = useAuth();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const form = useForm({
    initialValues: { username: '', password: '' },
    validate: zodValidator(loginSchema),
  });

  const from = (location.state as { from?: string } | null)?.from ?? '/';
  if (user) return <Navigate to={from} replace />;

  const submit = form.onSubmit(async (values) => {
    setSubmitting(true);
    setError(null);
    try {
      await login(values.username, values.password);
    } catch (err) {
      setError(errorMessage(err));
      form.setFieldValue('password', '');
    } finally {
      setSubmitting(false);
    }
  });

  return (
    <Center mih="100vh" p="md" bg="gray.1">
      <Paper withBorder shadow="sm" p="xl" radius="lg" w="100%" maw={400}>
        <form onSubmit={submit}>
          <Stack>
            <Stack align="center" gap="xs">
              <Title order={2}>Almacén de palets</Title>
              <Text c="dimmed" size="sm">
                Inicie sesión para continuar
              </Text>
            </Stack>
            {error && <Alert color="red">{error}</Alert>}
            <TextInput
              label="Usuario"
              autoComplete="username"
              autoFocus
              size="lg"
              {...form.getInputProps('username')}
            />
            <PasswordInput
              label="Contraseña"
              autoComplete="current-password"
              size="lg"
              {...form.getInputProps('password')}
            />
            <Button type="submit" size="lg" loading={submitting} fullWidth>
              Entrar
            </Button>
            <Image src="/efilogis-logo.png" alt="Efilogis" w={90} fit="contain" mx="auto" />
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
